import PropTypes from 'prop-types';
import Image from 'next/image';
import { Box, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import CustomContainer from 'components/Shared/CustomContainer';

import { whoIsContent as mock } from 'mocks/techVertical';
import StandardCTA from 'components/Buttons/StandardCTA';

import { handleSuccessButton } from 'utils/planUtils';

WhoIs.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      })
    ).isRequired,
  }),
};

WhoIs.defaultProps = {
  content: mock,
};

export default function WhoIs({ content }) {
  const theme = useTheme();
  const mobileBreakpoint = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box component="section" bgcolor="background.paper">
      <CustomContainer>
        <Typography
          fontWeight={700}
          mb={{ xs: 4, md: 8 }}
          textAlign="center"
          variant={mobileBreakpoint ? 'h5' : 'h4'}
        >
          {content?.title}
        </Typography>

        <Grid container alignItems="center" spacing={4}>
          {content.content.map((topic) => (
            <Grid item key={topic.title} md={3} sm={6} xs={12}>
              <Box textAlign="center">
                <Image
                  alt="clock"
                  height={100}
                  loader={({ src, width }) => `${src}?w=${width}`}
                  src={`/assets/svg/tech-vertical/${topic.icon}.svg`}
                  width={100}
                />

                <Typography
                  variant="subtitle2"
                  fontWeight={700}
                  my={2}
                  textTransform="uppercase"
                >
                  {topic.title}
                </Typography>

                <Typography variant="body2">{topic.text}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Box mt={8} textAlign="center">
          <StandardCTA
            text="Quero o tech english"
            onClick={handleSuccessButton}
          />
        </Box>
      </CustomContainer>
    </Box>
  );
}
